// src/plugins/builder/types.ts
// Public shape for the no-code builder. A "BuilderTemplate" is a recipe that
// (a) describes itself to the wizard UI, (b) emits a real plugin's source files
// when the user finishes the wizard, and (c) provides the runtime React/handler
// code that powers the user's plugin in-session.
//
// Strict no-fab rule: every shape here is consumed by real code in this folder.
/** An error that respects the "your work is saved" promise. */
export class BuilderError extends Error {
    reassure;
    constructor(message, reassure = "Don't worry — what you typed is still saved.") {
        super(message);
        this.reassure = reassure;
    }
}
